<template>
  <DSBadge
    v-if="statusBadgeProps"
    v-bind="statusBadgeProps"
    position-bottom
  >
    <DSUserAvatarContent v-bind="props" />
  </DSBadge>
  <DSUserAvatarContent
    v-else
    v-bind="props"
  />
</template>

<script setup lang="ts">
import DSBadge from "@/src/design_system/data_display/badge/components/DSBadge.vue";
import DSUserAvatarContent from "@/src/design_system/data_display/user/components/DSUserAvatarContent.vue";
import { useDSUserAvatar } from "@/src/design_system/data_display/user/composables/useDSUserAvatar";
import { DSUserAvatarProps } from "@/src/design_system/data_display/user/types/avatarProps";

const props = defineProps<DSUserAvatarProps>();

const { statusBadgeProps } = useDSUserAvatar(props);
</script>
